import { Card, CardContent, Typography } from "@mui/material";

export function ProductItem({ hit, components, colors }) {
  return (
    <a
      href={`/secured/transactions?tnxid=${hit.tnxId}&runtime=${hit.runtime}&state=${hit.state}`}
      className="aa-ItemLink"
    >
      <Card sx={{ minWidth: "400px", backgroundColor: `${colors.primary[900]} !important` }}>
        <CardContent>
          <Typography sx={{ fontSize: 14 }} color={colors.grey[100]} gutterBottom>
            Batch runtime {new Date(parseInt(hit.runtime)).toLocaleString()}
          </Typography>
          <Typography variant="h5" color={colors.grey[100]} component="div">
            {hit.state}
          </Typography>
          <Typography sx={{ mb: 1.5 }} color={colors.grey[100]}>
            {hit.doc.vehType}, {hit.doc.grossWeight}lb
          </Typography>
          <Typography sx={{ mb: 1.5, fontSize: 12 }} color={colors.grey[100]}>
            TNX ID {hit.tnxId}
          </Typography>
        </CardContent>
        {/* <CardActions>
          <Button size="small">Learn More</Button>
        </CardActions> */}
      </Card>
    </a>
  );
}
